<template>
  <v-container fluid>
      <v-data-iterator
        :items="locations"
        :loading="loading"
        :search="search"
        items-per-page="25"
      >
        <template v-slot:header>
          <v-toolbar>
            <v-toolbar-title>Locations</v-toolbar-title>
            <v-spacer/>
            <v-text-field
              prepend-inner-icon="search"
              v-model="search"
              hide-details
              single-line
            />
          </v-toolbar>
        </template>
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.id"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card height="100%">
                <v-card-title>
                  {{ item.name }}
                </v-card-title>
                <template v-for="batch in item.batches">
                  <BatchNavigation :instance="batch" :key="batch.id"/>
                </template>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
  </v-container>
</template>

<script>
import Location from "../../models/Location";
import BatchNavigation from "../../components/Batch/BatchNavigation";
export default {
  name: "LocationListView",
  components: {BatchNavigation},
  data() {
    return {
      loading: false,
      search: ""
    }
  },
  computed: {
    locations() {
      return Location.query()
        .with("batches")
        .with("rawmaterials")
        .get()
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Location.$fetch().then(() => this.loading = false)
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>
